<template>
  <VisionSidebar
    :class="$b()"
    :visible="visible"
    @close="close"
  >
    <div :class="$b('container')">
      <img
        :class="$b('logo')"
        src="~/assets/images/brand/sungod_logo.svg"
        title="SunGod"
      />
      <BaseCopy
        :class="$b('title')"
        size="h3"
      >
        Welcome!
      </BaseCopy>
      <BaseCopy
        :class="$b('intro')"
        size="body"
      >
        We use cookies to give you the best possible experience on the SunGod
        website. By confirming, you accept our use of cookies.
      </BaseCopy>

      <div :class="$b('checkbox-container')">
        <VisionCheckbox
          id="essential"
          v-model="essential"
          input-value="essential"
          disabled
          name="essential-cookies"
          :class="$b('checkbox')"
        >
          <BaseCopy
            size="body-sm"
            :class="$b('label')"
          >
            Technical cookies are required for our website to function properly,
            including functionality such as the shopping cart and checkout.
            <VisionLink
              size="small"
              theme="gradient"
              line-link
              :class="$b('text-link')"
              is-button
              @click.stop="openPrivacyPolicy"
            >
              Learn more
            </VisionLink>
          </BaseCopy>
        </VisionCheckbox>
        <VisionCheckbox
          id="optional"
          v-model="optional"
          input-value="optional"
          name="optional-cookies"
          :class="$b('checkbox')"
        >
          <BaseCopy
            size="body-sm"
            :class="$b('label')"
          >
            Performance cookies allow us to tailor your user experience based on
            your interests. We also use third-party cookies from carefully
            selected service providers for off-site advertising and analytics.
            <VisionLink
              size="small"
              theme="gradient"
              line-link
              :class="$b('text-link')"
              is-button
              @click.stop="openPrivacyPolicy"
            >
              Learn more
            </VisionLink>
          </BaseCopy>
        </VisionCheckbox>
      </div>

      <VisionButton
        size="small"
        background-colour="black"
        outline
        button-text="Submit"
        :class="$b('submit')"
        @click="close"
      />
    </div>
  </VisionSidebar>
</template>

<script>
export default {
  name: 'CookieSidebar',

  setup() {
    const pageStore = usePageStore()
    const sidebarStore = useSidebarStore()

    return { pageStore, sidebarStore }
  },

  data: () => ({
    essential: true,
    optional: true,
  }),

  computed: {
    visible() {
      return this.pageStore.showCookieModal
    },
  },

  watch: {
    visible(visible) {
      this.setOptionalStatus()
      this.pageStore.toggleBlockBodyScroll(visible)
    },
  },

  beforeMount() {
    if (this.visible) this.pageStore.toggleBlockBodyScroll(true)

    this.setOptionalStatus()
  },

  beforeUnmount() {
    this.pageStore.toggleBlockBodyScroll(false)
  },

  methods: {
    close() {
      this.pageStore.setCookieStatus(this.optional)
      this.pageStore.toggleCookieModal(false)
    },
    openPrivacyPolicy() {
      this.close()
      this.openSidebarPage('privacy-policy')
    },
    openSidebarPage(slug) {
      this.sidebarStore.setActiveSidebar(slug)
    },
    setOptionalStatus () {
      this.optional = this.pageStore.cookieStatus === null
        ? true
        : this.pageStore.cookieStatus
    }
  },
}
</script>

<style lang="postcss">
.CookieSidebar__container {
  @apply my-auto px-5;
  max-width: 420px;
}

.CookieSidebar__logo {
  @apply mt-xxs mb-md;
}

.CookieSidebar__title {
  @apply mb-sm;
}

.CookieSidebar__intro {
  @apply mb-md md:mb-lg;
}

.CookieSidebar__checkbox-container {
  @apply space-y-md;
}

.CookieSidebar__checkbox {
  @apply my-sm;
}

.CookieSidebar__label {
  @apply ml-xxxs mb-xxxs pb-0;
}

.CookieSidebar__text-link {
  transform: translateY(-2px);
}

.CookieSidebar__submit {
  @apply mt-sm md:mt-md
    mdMax:w-full;
}
</style>
